import React, { useMemo } from 'react'
import { SignalAssessment, SignalAssessmentDisplay } from 'scenes/Dashboard/data/signalAssessments/types'
import { makeStyles } from 'tss-react/mui'

import { List, Typography } from '@mui/material'

import BulletPoint from '../BulletPoint'

type SignalAssessmentsViewListProps = {
  signalAssessments: SignalAssessment[]
  displayableField?: keyof SignalAssessmentDisplay
}

export const SignalAssessmentsViewList = React.memo(
  ({ displayableField, signalAssessments }: SignalAssessmentsViewListProps) => {
    const { classes } = useStyles()
    const signalAssessmentsWithData = useMemo(
      () => signalAssessments.filter(({ assessmentSupportiveData }) => !!assessmentSupportiveData),
      [signalAssessments]
    )
    return (
      <List dense>
        {signalAssessmentsWithData.map((signal, index) => {
          const { summary, description } = signal.assessmentSupportiveData!
          const fieldToDisplay = displayableField === 'summary' ? summary : description
          if (!summary && !description) {
            return null
          }
          return (
            <BulletPoint
              key={index}
              className={classes.bulletPoint}
              item={
                <>
                  {!displayableField && <Typography variant="body1" dangerouslySetInnerHTML={{ __html: summary }} />}
                  <Typography variant="body2" dangerouslySetInnerHTML={{ __html: fieldToDisplay }} />
                </>
              }
            />
          )
        })}
      </List>
    )
  }
)

SignalAssessmentsViewList.displayName = 'SignalAssessmentsViewList'

const useStyles = makeStyles()({
  bulletPoint: { paddingTop: 0, paddingBottom: 0 },
})
